import React from 'react'
import {UniLink} from '../unilink/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/*function track(event) {
  console.log(event)
  // const app = this.props.track_app ? this.props.track_app + '_' : '';
  // mixpanel.track(`XP_${app}${event}`)
}*/

const FollowLinks = ({linkStyle, direction, className}) => {
  const linkClasses = ['social-media-link', linkStyle].join(' ')
  const followLinksClasses = ['follow-links', className, direction].join(' ')
  return (
    <div className={ followLinksClasses }>
      <UniLink
        className={ linkClasses }
        target='_blank'
        href='https://www.facebook.com/expii/'
        rel='noopener'
      >
        <FontAwesomeIcon icon={['fab', 'facebook-f']} />
      </UniLink>
      <UniLink
        className={ linkClasses }
        target='_blank'
        href='https://twitter.com/expii/'
        rel='noopener'
      >
        <FontAwesomeIcon icon={['fab', 'twitter']} />
      </UniLink>
      <UniLink
        className={ linkClasses }
        target='_blank'
        href='https://www.instagram.com/expii_/'
        rel='noopener'
      >
        <FontAwesomeIcon icon={['fab', 'instagram']} />
      </UniLink>
      <UniLink
        className={ linkClasses }
        target='_blank'
        href='https://youtube.com/expii'
        rel='noopener'
      >
        <FontAwesomeIcon icon={['fab', 'youtube']} />
      </UniLink>
    </div>
  )
}

FollowLinks.defaultProps = {
  linkStyle: 'buttons',
  direction: 'horizontal'
}

export default FollowLinks



// WEBPACK FOOTER //
// ./src/core/components/footer/FollowLinks.js